export const CLASS_NAMES = {
  wrapper:
    'hidden md:flex flex-row justify-between items-center pb-5 border-b border-solid border-neutral-200 mb-8 gap-x-2',
  titleWrapper: 'flex flex-col',
  title: 'text-24-32-em',
  subTitle: 'text-16-24-em text-gradient-b',
  logosWrapper: 'min-w-40 flex flex-col gap-y-2',
  poweredByKanda:
    'flex flex-row gap-x-2 items-center justify-between text-12-18-em text-neutral-500',
  trustPilot: 'w-40',
};
